
<template>
    <div class="permisos mt-2" v-if="detalle.length">
        <vs-row>
            <vs-col w="12" class="pr-3 py-2 mb-3 d-flex" style="border-bottom: 1px solid rgba(0, 0, 0, 0.125);">
                <div v-for="(ciclos, i) in detalle" :key="i">
                    <div @click="cicloSeleccionado = ciclos.ciclo_escolar, getFiltros([programaSeleccionado[i],i])" class="p-2" :class="cicloSeleccionado == ciclos.ciclo_escolar ? 'cicloSeletActive' : 'cicloSelet'">
                        <p class="mb-0"><strong>{{ ciclos.ciclo_escolar}}</strong></p>
                    </div>
                </div>
            </vs-col>
            <vs-col w="12">
                <div v-for="(ciclos, i) in detalle" :key="i" class="py-2 pl-5">
                    <tabla-programas v-show="ciclos.ciclo_escolar == cicloSeleccionado" :ciclos="ciclos" :posicion_ciclo="i" @filtros="getFiltros" @filtrosVacios="getFiltrosAlumnos" @filtrosModificados="getFiltrosModificados" :filtrosGenerales="filtrosGenerales"></tabla-programas>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import TablaProgramas from './detalle/tabla-programas.vue'
export default {
    props: [
        'detalle', 
        'cicloEscolar',
        'cicloEscolares',
        'filtrosGenerales'
    ],
    data:() => ({
        cicloSeleccionado: '',
        programaSeleccionado: [],
    }),
    components:{
        TablaProgramas
    },
    methods: {
        getFiltros(obj){
            const cicloSeleccionado = {
                cicloSeleccionado: this.cicloSeleccionado,
                programaSeleccionado: obj[0]
            }
            this.$emit('filtros', cicloSeleccionado)
            this.programaSeleccionado[obj[1]] = obj[0]
        },
        getFiltrosAlumnos(filtros){
            this.$emit("filtrosVacios", filtros)
        },
        getFiltrosModificados(obj){
            this.$emit("filtrosModificados", obj)
        }
    },
    watch:{
        detalle(){
            this.cicloSeleccionado = this.filtrosGenerales.cicloSeleccionado
            this.programaSeleccionado = []
            this.detalle.forEach(d => {
                this.programaSeleccionado.push(d.ciclo_escolar == this.filtrosGenerales.cicloSeleccionado ? this.filtrosGenerales.programaSeleccionado : d.programas[0].programa)
            })
        },
    }
}
</script>
<style>
.botonProgramaActive{
    cursor: pointer;
    background: #34495E;
    border-radius: 0 30px 0 0;
    color: white;
    border-left: 4px solid #7cb2e7;
}
.botonPrograma  {
    cursor: pointer;
    background: #f7f7f7;
}

.cicloSeletActive{
    background: #34495E;
    color: white;
    border-radius: 4px;
}
.cicloSelet{
    background: #f7f7f7;
    color: #858796;
}
</style>
<style lang="scss" scoped >

.borderTarjeta{
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
}

@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
    @include text-colors ('blue', #2d8bf6, #deecfc ); 
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236) );
}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);  
    @include text-colors ('blue', #92bff1, #c7e1ff ); 
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236) );
}

.col-purple{
    color: purple;
    background: rgb(234, 228, 236);
}
.fontBiger{
    font-size: 22px;
}
.fontBig{
    font-size: 16px;
}
.fontMedium{
    font-size: 15px;
}

.fontSmall{
    font-size: 12px;
}

.breakInfo{
    word-break: break-all;
}
.permisos{
    .encabezado{
        border-radius: 14px 14px 0 0;
        background: #F4F7F8;
        padding: 10px 12px;
    }
    .sinInfo{
        padding: 20px;
        text-align: center;
    }
    details:not(:last-child){
        border-bottom: 2px solid #ececec;
    }
    details summary{
    font-size: 15px;
    }
}
</style>
<style scoped>
  .divisionLineasTop:not(:first-child){
      border-top: 1px solid #E5E7E9; 
  }
  .divisionLineasTop{
      padding: 2% 0;
  }
  .borderMes{
    background: white;
    border: 1px solid #E5E7E9; 
    padding: 4%;
    margin: 3% 5%;
    border-radius: 8px;
  }
  .cardIndividual{
    border: 1px solid #efefef;
    border-radius: 7px;
    padding: 6px 8px;
    margin:5px;
  }
  .colorTag{
    border-bottom: 2px solid #9fd95c;
    padding: 4px 10px;
    background: #d7f1ba;
    color: black;
    border-radius: 5px 60px 10px 5px;
  }
  .programasLista{
    display: -webkit-box;
    overflow: auto;
    width: 100%;
  }
  
  .programasLista::-webkit-scrollbar {
    -webkit-appearance: none;
}

.programasLista::-webkit-scrollbar:vertical {
    width:10px;
}

.programasLista::-webkit-scrollbar-button:increment,.programasLista::-webkit-scrollbar-button {
    display: none;
} 

.programasLista::-webkit-scrollbar:horizontal {
    height: 10px;
}

.programasLista::-webkit-scrollbar-thumb {
    background-color: #797979;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.programasLista::-webkit-scrollbar-track {
    border-radius: 10px;  
}
</style>

